// Detects in-app browsers (webviews), where Google Sign-In cannot work.
//
// Google does not support user sign-in inside Android and iOS webviews: the button
// renders, the popup opens, and Google refuses. About 37% of signup sessions arrive
// from the Facebook / Instagram in-app browsers, so the Google buttons are hidden
// there (isGoogleSignInAvailable in googleSignInAvailability.js).
//
// Deliberately separate from the narrower autofill regex in
// visits/components/signup.jsx: that one drives autoComplete="off" for the whole
// form, and widening it would change the form's autofill behaviour.
//
// Markers: Android WebView (the "wv" token), Facebook (FB_IAB / FBAN / FBAV, which
// also cover Messenger), Instagram, Line, TikTok (musical_ly / BytedanceWebview),
// Snapchat, Pinterest, LinkedIn. Webviews without a marker slip through: those
// visitors see Google's own error in the popup and can still use the form.
export const EMBEDDED_BROWSER_UA =
  /Android.*\bwv\b|FB_IAB|FBAN|FBAV|Instagram|Messenger|\bLine\/|TikTok|BytedanceWebview|musical_ly|Snapchat|Pinterest|LinkedInApp/i;

// isEmbeddedWebView reports whether a user agent is an in-app browser. Pass a
// string to test one explicitly; it defaults to this browser's.
export function isEmbeddedWebView(ua = navigator.userAgent) {
  return EMBEDDED_BROWSER_UA.test(ua || "");
}
